<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <a class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#" data-bs-toggle="modal" data-bs-target="#AddForumModal">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un forum
        </a>

      </div>
      <div class="d-flex align-items-center">

        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher un forum" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Description
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Users
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(forum, index) in forums" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ forum.nom }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ forum.description }}
              </td>
              <td>
                <ul>
                  <li v-for="(userForum, uIndex) in forum.userForums" :key="uIndex">
                    {{ userForum?.user.nomComplet }}
                  </li>
                </ul>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        data-bs-toggle="modal" data-bs-target="#AddForumModal" @click="moddifier(forum)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(forum.id, forums, 'forums', 'le forum ' + forum.nom)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddForumModal :item="selectedItem" @close="recharger" />
</template>
<script lang="ts">

import { defineComponent, onMounted, ref } from "vue";
import AddForumModal from "./AddForumModal.vue";
import ApiService from "../../services/ApiService";
import { suppression, error } from "../../utils/utils";

import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { Forum } from "@/models/Forum";

export default defineComponent({
  name: "ListeForum",
  components: {
    AddForumModal,
    PaginationComponent
  },
  setup: () => {
    const modules = {

    };

    const forums = ref<Array<Forum>>([]);
    const forum = ref<Forum>();
    const addForumModalRef = ref<null | HTMLElement>(null);
    const selectedItem = ref(0);

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllForum(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher() {
      getAllForum(page.value, limit.value, searchTerm.value);
    }

    // END PAGINATE

    function getAllForum(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/forums?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {

          console.log(data, "huuuuuuuuuuuuu");
          forums.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    onMounted(() => {
      getAllForum();
    });

    function moddifier(EditForum: Forum) {
      forum.value = EditForum;
      selectedItem.value = EditForum.id;
    }
    const recharger = () => {
      getAllForum();
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    return {
      modules,
      checkPermission,
      selectedItem,
      forums,
      recharger,
      suppression,
      moddifier,
      page,
      totalPages,
      limit,
      totalElements,
      getAllForum,
      handlePaginate,
      searchTerm,
      rechercher, addForumModalRef
    };
  },
});
</script>
